import React, { useState } from "react";
import { useCart } from "../context/CartContext";

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true);
    addToCart(product);
    setTimeout(() => setClicked(false), 200); // reset animation
  };

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "10px",
        padding: "15px",
        margin: "10px",
        width: "220px",
        textAlign: "center",
        background: "#fff",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      }}
    >
      <img
        src={product.image}
        alt={product.name}
        style={{
          width: "100%",
          height: "150px",
          objectFit: "cover",
          borderRadius: "10px",
        }}
      />
      <h3 style={{ margin: "10px 0" }}>{product.name}</h3>
      <p style={{ color: "green", fontWeight: "bold" }}>
        Rs {product.price} Per Kg/Dozen {product.unit}
      </p>

      <button
        onClick={handleClick}
        style={{
          marginTop: "10px",
          padding: "8px 15px",
          background: clicked ? "#218838" : "#28a745", // darker on click
          transform: clicked ? "scale(0.95)" : "scale(1)", // scale effect
          transition: "all 0.2s ease-in-out",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        {clicked ? "Adding..." : "Add to Cart"}
      </button>
    </div>
  );
};

export default ProductCard;
